import { SVGProps } from 'react';

import { styleConfigs } from '../../resources/styleConfigs';

const ArrowBackIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  fill = 'currentColor',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 20L13.41 18.59L7.83 13L20 13L20 11L7.83 11L13.42 5.42L12 4L4 12L12 20Z" fill={fill} />
  </svg>
);

export default ArrowBackIcon;
